$(document).ready(function(){
  let token = 'IWISH_API_8aa1f7e4648011ef96ef0e72f2521631';
  $(document).on('click', '.tooltip.favourite.is--empty', function(){
    let customerId = parseInt($(this).attr('customer_id'));
    let productId = parseInt($(this).attr('product_id'));
    let variantId = parseInt($(this).attr('variant_id'));
    let $this = $(this);

    const settings = {
      async: true,
      crossDomain: true,
      url: `https://api.myshopapps.com/wishlist/V1/addToWishlist/`,
      method: 'POST',
      headers: {
        xtoken: token,
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      },
      data: {
        customer_id: customerId,
        product_id: productId,
        variant_id: variantId,
        category_id: 0,
        product_qty: 1
      }
    };

    $.ajax(settings).done(function (response) {
      if(response.result == 'OK'){
        $this.removeClass('is--empty');
        $this.addClass('is--filled');
      }
    });
  });
 
  $(document).on('click', '.tooltip.favourite.is--filled', function(){
    let customerId = parseInt($(this).attr('customer_id'));
    let productId = parseInt($(this).attr('product_id'));
    let variantId = parseInt($(this).attr('variant_id'));
    let $this = $(this);

    const settings = {
      async: true,
      crossDomain: true,
      url: 'https://api.myshopapps.com/wishlist/V1/removeWishlist/',
      method: 'POST',
      headers: {
        xtoken: token,
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      },
      data: {
        customer_id: customerId,
        product_id: productId,
        variant_id: variantId,
        category_id: 0
      }
    };

    $.ajax(settings).done(function (response) {
      if(response.result == 'OK'){
        $this.removeClass('is--filled');
        $this.addClass('is--empty');
      }
    });
  });

  $('.tooltip.favourite').each(function(){
    let customerId = parseInt($(this).attr('customer_id'));
    let productId = parseInt($(this).attr('product_id'));
    let variantId = parseInt($(this).attr('variant_id'));
    let $this = $(this);

    const settings = {
      async: true,
      crossDomain: true,
      url: 'https://api.myshopapps.com/wishlist/V1/checkInWishlist/',
      method: 'POST',
      headers: {
        xtoken: token,
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json'
      },
      data: {
        customer_id: customerId,
        product_id: productId,
        variant_id: variantId,
      }
    };

    $.ajax(settings).done(function (response) {
      if(response.result == 'True'){
        $this.removeClass('is--empty');
        $this.addClass('is--filled');
      }
    });

  });
  /* end wishlist add and remove using api call */

  $(document).on('click', '.tooltip.favourite.no-customer', function(){
    if($(this).hasClass('must-login')){
      $('.tooltip.favourite.no-customer').removeClass('must-login')
    }else{
      $('.tooltip.favourite.no-customer').removeClass('must-login')
      $(this).addClass('must-login');
    }
  });
  $('body').click(function(e) {
    if($(e.target).find('.tooltip.favourite.no-customer.must-login').length > 0){
      $('.tooltip.favourite.no-customer').removeClass('must-login')
    }
  });
});